import { Link } from "react-router-dom";
import { Carousel, Image } from 'react-bootstrap';
import Loader from './Loader';
import Message from './Message';
import { useGetTopProductsQuery } from "../slices/productsApiSlice";
import accounting from 'accounting-js';

const ProductCarousel = () => {
  const { data: products, isLoading, error } = useGetTopProductsQuery();

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant='danger'>
      {error?.data?.message || error?.error || 'Slayt yüklenirken bir hata oluştu.'}
    </Message>
  ) : (
    <Carousel pause='hover' className='bg-primary mb-4' style={{ zIndex: -1 }}>

      <Carousel.Item>
        <div className="carousel-img-wrap">
          <Image src="/uploads/Proje.jpg" alt="Otomasyon Proje Uygulamaları" />
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="carousel-img-wrap">
          <Image src="/uploads/Yazilim.jpg" alt="Yazılım" />
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="carousel-img-wrap">
          <Image src="/uploads/Egitim.jpg" alt="Eğitim" />
        </div>
      </Carousel.Item>
      <Carousel.Item>
        <div className="carousel-img-wrap">
          <Image src="/uploads/Oto1.jpg" alt="Otomasyon" />
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="carousel-img-wrap">
          <Image src="/uploads/salt1.jpg" alt="Şalt Malzemeleri" />
        </div>
      </Carousel.Item>

      <Carousel.Item>
        <div className="carousel-img-wrap">
          <Image src="/uploads/Kablo.jpg" alt="Kablo" />
        </div>
      </Carousel.Item>


    </Carousel>
  );
};

export default ProductCarousel;


